import { Week, WeekIdentifier } from '../Incrementals.types';
import { UiQueries } from './UiQueries';

export function getWeekQuery(
  this: UiQueries,
  weekId: WeekIdentifier | null
): Week | null {
  if (weekId == null) {
    return null;
  }
  // There should always be a match
  const currentWeek = this.uiState.weeks.filter(
    (week) => week.weekId === weekId
  )[0];

  return currentWeek;
}
